import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
  computed,
} from '@angular/core';

import { ChipGroupComponent, ChipOption } from '@shared/chips';
import { FilterGroup } from '../../../models';

@Component({
  selector: 'app-filter-chip-group',
  standalone: true,
  imports: [ChipGroupComponent],
  template: `
    <app-chip-group
      [options]="chipOptions()"
      [ariaLabel]="group().title"
      (selectionChange)="onSelectionChange($event)"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterChipGroupComponent {
  group = input.required<FilterGroup>();

  selectionChange = output<string[]>();

  chipOptions = computed<ChipOption[]>(() =>
    this.group().options.map((opt) => ({
      id: opt.id,
      label: opt.label,
      selected: opt.selected,
      disabled: opt.disabled,
    }))
  );

  onSelectionChange(selectedIds: string[]): void {
    this.selectionChange.emit(selectedIds);
  }
}
